var _circle, _circle2, _circle3, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGetCreditIcon = function SvgGetCreditIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 40,
    viewBox: "0 0 37 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 20,
    r: 17,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 20,
    r: 15,
    fill: "#60BC57",
    fillOpacity: 0.34
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 20,
    r: 15,
    fill: "url(#get-credit-icon_svg__a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.84 38c2.987 0 5.927-.73 8.56-2.125A18.104 18.104 0 0 0 31.94 30a17.857 17.857 0 0 0 1.678-16.889 18.012 18.012 0 0 0-5.257-7.025 18.23 18.23 0 0 0-7.978-3.74 18.314 18.314 0 0 0-8.814.43A18.191 18.191 0 0 0 4 7.271m0 0L4.5 1.5M4 7.272l5.5.228",
    stroke: "#25A55A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 12a.572.572 0 0 0-.572.571v1.179c-.845.088-1.62.37-2.217.857-.73.595-1.18 1.505-1.18 2.536 0 1.125.595 1.918 1.34 2.375.746.456 1.616.682 2.414 1 1.308.476 3.04 1.003 3.058 2.339 0 .7-.295 1.224-.787 1.625-.492.401-1.207.66-2.056.66-1.389 0-2.464-.857-2.932-1.642-.127-.302-.527-.439-.805-.268-.278.17-.352.606-.143.857a4.556 4.556 0 0 0 3.326 2.143c0 .02-.018.034-.018.054v1.143a.572.572 0 0 0 1.144 0V26.25c.845-.093 1.62-.388 2.217-.875a3.204 3.204 0 0 0 1.18-2.518c0-1.125-.595-1.936-1.34-2.392-.746-.457-1.616-.683-2.414-1-1.3-.476-3.04-1.002-3.058-2.322 0-.7.295-1.242.787-1.643.492-.4 1.207-.643 2.056-.643 1.389 0 2.465.84 2.932 1.625.127.303.527.44.805.268.278-.17.352-.606.143-.857-.597-1.002-1.772-1.936-3.326-2.125 0-.02.018-.034.018-.054v-1.143A.572.572 0 0 0 15 12Z",
    fill: "#25A55A",
    stroke: "#25A55A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.876 18.258v4.55M21.752 20.533H26",
    stroke: "#229954",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "get-credit-icon_svg__a",
    x1: 8.627,
    y1: 9.459,
    x2: 27,
    y2: 31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8F8F9"
  })))));
};
export default SvgGetCreditIcon;